import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { COMMON_API } from '../../CommonAPI';

const EditTeam = () => {
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [previewImage, setPreviewImage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const token = sessionStorage.getItem('authToken');
        const res = await axios.get(`${COMMON_API}/api/team/get-team`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const member = res.data.find(team => team.id === parseInt(id));
        if (member) {
          setForm({ ...member, image: null }); // set image as null initially
          setPreviewImage(`${COMMON_API}/api/upload/${member.image}`);
        }
      } catch {
        toast.error('Failed to fetch team member');
      }
    };
    fetchTeam();
  }, [id]);

  const handleChange = e => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setForm({ ...form, image: files[0] });
      setPreviewImage(URL.createObjectURL(files[0]));
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const token = sessionStorage.getItem('authToken');
      const formData = new FormData();
      for (const key in form) {
        if (form[key]) formData.append(key, form[key]);
      }

      await axios.post(`${COMMON_API}/api/team/edit-team`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        }
      });

      toast.success('Team member updated!');
      navigate('/team');
    } catch {
      toast.error('Update failed');
    }
  };

  return (
    <div className="ml-64 p-8 bg-gray-100 min-h-screen">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-2xl font-semibold mb-4">Edit Team Member</h2>

        <input
          type="hidden"
          name="id"
          value={form.id || ''}
        />

        <input
          type="text"
          name="name"
          placeholder="NAME"
          value={form.name || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />

        <input
          type="text"
          name="designation"
          placeholder="DESIGNATION"
          value={form.designation || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />

        <div>
          <label className="block mb-1 text-sm">Image</label>
          {previewImage && (
            <img src={previewImage} alt="Preview" className="w-32 h-20 mb-2 rounded object-cover" />
          )}
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded"
          />
        </div>

        <textarea
          name="content"
          placeholder="CONTENT"
          value={form.content || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />

        <input
          type="text"
          name="fb_link"
          placeholder="FB LINK"
          value={form.fb_link || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />

        <input
          type="text"
          name="insta_link"
          placeholder="INSTA LINK"
          value={form.insta_link || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />

        <input
          type="text"
          name="linked_in_link"
          placeholder="LINKEDIN LINK"
          value={form.linked_in_link || ''}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />

        <button type="submit" className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600">
          Update
        </button>
      </form>
    </div>
  );
};

export default EditTeam;
 